import { flowRight } from "lodash";

import { type AttributionModel } from "../attribution-models";

/*
  This is ONLY used for the attribution model name because we don't want to show the
  company name in the UI, but the name of the attribution model is stored in the database
  with the company name in it as {{{ companyName }}} in the `custom_attribution_models` table.
*/
export const formatAttributionModel = (name: AttributionModel["name"]) => {
  const companyNameMustacheRegex = /{{{\s?companyName\s?}}}/g;
  if (!companyNameMustacheRegex.test(name)) {
    return name;
  }

  const removeCompanyNameMustaches = (value: AttributionModel["name"]) =>
    value.replace(companyNameMustacheRegex, "").trim();
  const removeParentheses = (value: AttributionModel["name"]) =>
    value.replace(/([()])/g, "").trim();

  const sanitizeAttributionModel = flowRight(
    removeCompanyNameMustaches,
    removeParentheses,
  );

  return sanitizeAttributionModel(name);
};
